
import GwSection from '~/patterns/organisms/section/section.vue';
import GwQuote from '~/patterns/atoms/quote/presets/pullquote.vue';

export default {
    components: {
        GwSection,
        GwQuote
    },

    props: {
        quote: {
            type: String,
            required: true,
            default: null
        },
        author: {
            type: String,
            required: false,
            default: null
        },
        wrapWithQuotationMarks: {
            type: Boolean,
            required: false,
            default: true
        }
    },
};
